import dateFormat from "dateformat";

const DateTime = (el) => {
  el.style.position = "relative";
  el.style.overflow = "hidden";

  const required = el.dataset.required === "true";
  const value = el.querySelector("[data-value]");
  const children = [...el.children];
  let isOpen = false;

  const bg = document.createElement("div");
  bg.style.position = "absolute";
  bg.style.top = 0;
  bg.style.left = 0;
  bg.style.width = "100%";
  bg.style.height = "100%";
  bg.style.backgroundColor = "white";
  bg.style.zIndex = 2;
  el.appendChild(bg);

  const input = document.createElement("input");
  const min = new Date();
  min.setDate(min.getDate() + 1);
  const max = new Date();
  max.setMonth(max.getMonth() + 2);

  input.setAttribute("type", "datetime-local");
  if (required) input.setAttribute("required", required);
  input.setAttribute("min", min.toISOString().slice(0, 16));
  input.setAttribute("max", max.toISOString().slice(0, 16));
  input.value = undefined;

  input.style.position = "absolute";
  input.style.top = 0;
  input.style.left = 0;
  input.style.width = "100%";
  input.style.height = "100%";
  input.style.zIndex = 1;

  el.appendChild(input);

  children.forEach((child) => {
    child.style.position = "relative";
    child.style.zIndex = 10;
  });

  el.addEventListener("click", () => {
    if (input.showPicker) {
      input.showPicker();
      isOpen = true;
      document.querySelector(
        '[data-component="overlay"]',
      ).dataset.componentForceOpen = "true";
    }
  });

  window.addEventListener("click", (e) => {
    if (isOpen && !el.contains(e.target)) {
      isOpen = false;
      document.querySelector(
        '[data-component="overlay"]',
      ).dataset.componentForceOpen = "";
    }
  });

  input.addEventListener("change", (e) => {
    value.textContent = dateFormat(
      e.target.value,
      "dddd, mmmm dS, yyyy, h:MM:ss TT",
    );
    isOpen = false;
    document.querySelector(
      '[data-component="overlay"]',
    ).dataset.componentForceOpen = "";
  });
};

export default DateTime;
